<template>
	<v-dialog v-model="dialogState" width="600">
		<v-card>
			<v-card-title class="headline">
				{{ header }}
			</v-card-title>

			<v-card-text>
				{{ content }}
			</v-card-text>

			<div v-if="showBidderChangesCheckbox" class="ml-3">
				<v-tooltip top>
					<template v-slot:activator="{ on }">
						<div v-on="on">
							<v-checkbox
								class="ml-3"
								label="Pozwól na edycję przez głównego oferenta"
								v-model="allowMainBidderChanges"
								aria-label="allow main bidder changes"/>
						</div>
					</template>
					<span>
						Pozwól głównemu oferentowi na dokonywanie zmian w wysłanym sprawozdaniu.<br/>
						W przeciwnym wypadku główny oferent nie może edytować wysłanego sprawozdania.
					</span>
				</v-tooltip>
			</div>


			<v-alert :value="true" type="info" outline class="ml-4 mr-4 mb-3">
				Po wysłaniu sprawozdania należy złożyć jego podpisaną wersję!
			</v-alert>

			<v-divider></v-divider>

			<v-card-actions>
				<v-spacer></v-spacer>
				<v-btn color="success" flat @click="action(allowMainBidderChanges)" :loading="loading" :disabled="loading">
					<v-icon color="white" class="mr-2 white--text">{{ icon }}</v-icon>
					{{ actionLabel }}
				</v-btn>
				<v-btn color="blue" @click="dialogState = false">
					<v-icon color="white" class="mr-2 white--text">close</v-icon>
					Anuluj
				</v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>
	export default {
		name: "ProjectFinalReportConfirmationDialog",

		data () {
			return {
				dialogState: false,
        allowMainBidderChanges: false
			};
		},

		watch: {
			dialogModel: function () {
				this.dialogState = this.dialogModel;
			},

			dialogState: function (val) {
				if (!val) this.$emit("close-confirmation");
			}
		},

		props: {
			dialogModel: Boolean,
			header: String,
			content: String,
			actionLabel: String,
			icon: String,
			action: Function,
    showBidderChangesCheckbox: {type: Boolean, default: true},
	loading: {type: Boolean, default: false}
		}
	};
</script>

<style scoped>

</style>
